import React, { Component } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Keyboard,
  Button,
  Platform,
  ScrollView,
} from "react-native";
import Text from "../components/Text";
import Color from "react-native-material-color";
import { connect } from "react-redux";
import DateTimePicker from "react-native-modal-datetime-picker";
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import MapView from 'react-native-maps';
import Modal from "react-native-modalbox";
import * as Location from "expo-location";
// import { Constants as ExpoConstants } from 'expo-constants';
import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import moment from "moment";

import * as actions from "../actions/registerFirstStep";
import * as Commons from "../utils/Commons";
import * as Styles from "../utils/Styles";
import { STRINGS } from "../utils/Strings";

let styles = {};
class RegisterFirstStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyboardVisible: false,
    };

    this._genderASOptions = [STRINGS.male, STRINGS.female, STRINGS.cancel];
    this._maritalStatusASOptions = [
      STRINGS.single,
      STRINGS.married,
      STRINGS.cancel,
    ];

    this._genderASValues = ["0", "1", "-1"];
    this._maritalStatusASValues = ["0", "1", "-1"];
  }

  async componentDidMount() {
    this._mounted = true;
    this.props.updateState({ birthdate: "" });
    const { user } = this.props;
    if (user) {
      this.props.setupUserInfo(user);
    } else {
      this.getUserLocation();
    }

    const language = await Commons.language();
    const fontFamily = language.startsWith("ar") ? "iran" : "riposte";
    const textAlign = language.startsWith("ar") ? "right" : "left";
    const fontSize = language.startsWith("ar") ? 13 : 15;
    styles = myStyle({ fontFamily, fontSize, textAlign });
    this.props.updateState({ fontFamily, fontSize, textAlign });
  }

  UNSAFE_componentWillMount() {
    this._mounted = false;
    this._addKeyboardListeners();
  }

  componentWillUnmount() {
    if (this.props.popTwice) {
      this.props.navigation.pop(1);
    }
    this.props.resetState();
    this._removeKeyboardListeners();
  }

  _addKeyboardListeners = () => {
    this.keyboardDidShowListener = Keyboard.addListener(
      "keyboardDidShow",
      this._keyboardDidShow
    );
    this.keyboardDidHideListener = Keyboard.addListener(
      "keyboardDidHide",
      this._keyboardDidHide
    );
  };

  _removeKeyboardListeners = () => {
    this.keyboardDidShowListener.remove();
    this.keyboardDidHideListener.remove();
  };

  _keyboardDidShow = () => {
    this.setState({ keyboardVisible: true });
  };

  _keyboardDidHide = () => {
    this.setState({ keyboardVisible: false });
  };

  render() {
    const sharedProps = {
      style: [styles.input, !Styles.isLtr() && { textAlign: "right" }],
      placeholderTextColor: Color.GREY[400],
      numberOfLines: 1,
    };
    return (
      <View
        style={[
          styles.container,
          this.state.keyboardVisible && {
            paddingBottom: 0,
            justifyContent: "center",
            alignContent: "center",
          },
        ]}
      >
        <View style={[{ alignSelf: "center" }, Styles.subContainerMedium]}>
          {/* {Commons.renderAppBackground()} */}
          <ScrollView
            enableAutomaticScroll
            enableOnAndroid
            extraScrollHeight={Platform.select({
              android: this.state.keyboardVisible ? 150 : 0,
            })}
            keyboardShouldPersistTaps={"always"}
          >
            <Text style={styles.title}>{STRINGS.registration_step_1}</Text>

            {/* First Name */}
            <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                defaultValue={this.props.firstName}
                placeholder={STRINGS.first_name}
                onChangeText={(text) =>
                  this.props.updateState({ firstName: text })
                }
              />
            </View>

            {/* Last Name */}
            <View style={styles.optionView}>
              <TextInput
                {...sharedProps}
                defaultValue={this.props.lastName}
                placeholder={STRINGS.last_name}
                onChangeText={(text) =>
                  this.props.updateState({ lastName: text })
                }
              />
            </View>

            {/* birthdate */}
            {/* <View style={styles.optionView}>
                        <View style={styles.labelView}>
                            <Text style={styles.label}>{STRINGS.birthdate} *</Text>
                        </View>
                        <TouchableOpacity
                            style={[styles.input, { flex: 1.5, justifyContent: 'center' }]}
                            activeOpacity={0.9}
                            onPress={this.showDatePicker}
                        >
                            <Text style={[styles.hint, this.props.birthdate !== STRINGS.choose_date && { color: 'black' }]}>
                                {this.props.birthdate}
                            </Text>
                        </TouchableOpacity>
                    </View> */}

            {/* birthdate */}
            {/* <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.birthdate} </Text>
              </View>
              <TextInput
                {...sharedProps}
                keyboardType="number-pad"
                returnKeyType="done"
                placeholder={"yyyy-MM-dd"}
                defaultValue={this.props.birthdate}
                maxLength={10}
                onChangeText={(text) => {
                  if (text.match(/^\d{4}$/) !== null) {
                    text += "-";
                  } else if (text.match(/^\d{4}-\d{2}$/) !== null) {
                    text += "-";
                  }
                  this.props.updateState({ birthdate: text });
                }}
              />
            </View> */}

            {/* Mobile Number */}
            <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.mobile_number} *</Text>
              </View>
              <TextInput
                {...sharedProps}
                keyboardType="number-pad"
                returnKeyType="done"
                placeholder={`07 (9 ${STRINGS.digits})`}
                defaultValue={this.getMobile(0)}
                onChangeText={(text) => {
                  const mobile = text;
                  const newMobile = this.getNewMobile(mobile, 0);
                  this.props.updateState({ mobile: newMobile });
                }}
              />
            </View>

            {/* Mobile Number 2 */}
            {/* <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.mobile_number_2}</Text>
              </View>
              <TextInput
                {...sharedProps}
                keyboardType="number-pad"
                returnKeyType="done"
                placeholder={STRINGS.optional}
                defaultValue={this.getMobile(1)}
                onChangeText={(text) => {
                  const mobile = text;
                  const newMobile = this.getNewMobile(mobile, 1);
                  this.props.updateState({ mobile: newMobile });
                }}
              />
            </View> */}

            {/* Land Line */}
            {/* <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.land_line}</Text>
              </View>
              <TextInput
                {...sharedProps}
                placeholder={STRINGS.optional}
                defaultValue={this.getMobile(2)}
                keyboardType="number-pad"
                returnKeyType="done"
                onChangeText={(text) => {
                  const mobile = text;
                  const newMobile = this.getNewMobile(mobile, 2);
                  this.props.updateState({ mobile: newMobile });
                }}
              />
            </View> */}
            {/* Gender */}
            {/* {Platform.OS === 'android' && (
            <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.gender}</Text>
              </View>
              <TouchableOpacity
                style={[styles.input, { flex: 1.5, justifyContent: 'center' }]}
                activeOpacity={0.9}
                onPress={() => this.genderAS.show()}
              >
                <Text style={[styles.hint, { color: 'black' }]}>{Commons.getGenderName(this.props.gender)}</Text>
              </TouchableOpacity>
            </View>
          )}
          <ActionSheet
            ref={el => (this.genderAS = el)}
            title={STRINGS.gender}
            options={this._genderASOptions}
            cancelButtonIndex={2}
            onPress={index => {
              if (index !== 2) {
                this.props.updateState({ gender: this._genderASValues[index] });
              }
            }}
          /> */}

            {/* Marital Status */}
            {/* <View style={styles.optionView}>
                        <View style={styles.labelView}>
                            <Text style={styles.label}>{STRINGS.marital_status}</Text>
                        </View>
                        <TouchableOpacity
                            style={[styles.input, { flex: 1.5, justifyContent: 'center' }]}
                            activeOpacity={0.9}
                            onPress={() => this.maritalStatusAS.show()}
                        >
                            <Text style={[styles.hint, { color: 'black' }]}>{Commons.getMaritalStatus(this.props.maritalStatus)}</Text>
                        </TouchableOpacity>
                    </View>
                    <ActionSheet
                        ref={el => (this.maritalStatusAS = el)}
                        title={STRINGS.marital_status}
                        options={this._maritalStatusASOptions}
                        cancelButtonIndex={2}
                        onPress={index => {
                            if (index !== 2) {
                                this.props.updateState({ maritalStatus: this._maritalStatusASValues[index] });
                            }
                        }}
                    /> */}

            {/* Number Of Children */}
            {/* <View style={styles.optionView}>
                        <View style={styles.labelView}>
                            <Text style={styles.label}>{STRINGS.number_of_children}</Text>
                        </View>
                        <TextInput
                            {...sharedProps}
                            keyboardType="numeric"
                            placeholder="1, 2, 3 ..."
                            defaultValue={this.props.numOfChildren}
                            onChangeText={text => this.props.updateState({ numOfChildren: text })}
                        />
                    </View> */}
            {/* <View style={styles.optionView}>
            <View style={styles.labelView}>
              <Text style={styles.label}> {STRINGS.addressUsage}</Text>
            </View>
          </View> */}
            {/* Address */}
            <View style={styles.optionView}>
              <View style={styles.labelView}>
                <Text style={styles.label}>{STRINGS.address} *</Text>
              </View>
              <TextInput
                {...sharedProps}
                defaultValue={this.getAddress(false)}
                placeholder={`${STRINGS.address}`}
                onChangeText={(text) => {
                  const address = text;
                  const newAddress = this.getNewAddress(address, false);
                  this.props.updateState({ address: newAddress });
                }}
              />
              <TouchableOpacity
                style={styles.mapIcon}
                onPress={() => {
                  this.addressModal.open();
                  setTimeout(() => {
                    this.props.updateState({
                      showMapView: true,
                      isSecondAddress: false,
                    });
                    setTimeout(() => {
                      this.moveToRegion(this.props.mapRegion);
                    }, 250);
                  }, 250);
                }}
              >
                <MaterialCommunityIcons
                  name="google-maps"
                  size={28}
                  color={Color.BLUE[500]}
                />
              </TouchableOpacity>
            </View>

            {/* Address 2 */}
            {/* <View style={styles.optionView}>
            <View style={styles.labelView}>
              <Text style={styles.label}>{STRINGS.address_2}</Text>
            </View>
            <TextInput
              {...sharedProps}
              defaultValue={this.getAddress(true)}
              placeholder={`${STRINGS.optional}`}
              onChangeText={text => {
                const address = text;
                const newAddress = this.getNewAddress(address, true);
                this.props.updateState({ address: newAddress });
              }}
            />
            <TouchableOpacity
              style={styles.mapIcon}
              onPress={() => {
                this.addressModal.open();
                setTimeout(() => {
                  this.props.updateState({ showMapView: true, isSecondAddress: true });
                  setTimeout(() => {
                    this.moveToRegion(this.props.secondMapRegion);
                  }, 250);
                }, 250);
              }}
            >
              <MaterialCommunityIcons name="google-maps" size={28} color={Color.BLUE[500]} />
            </TouchableOpacity>
          </View>
          {Platform.OS === 'android' && this.state.keyboardVisible && <View style={{ height: 150 }} />} */}
          </ScrollView>
          {/* Bottom Buttons */}
          {!this.state.keyboardVisible && (
            <View style={[Styles.bottomView, { padding: 0 }]}>
              <TouchableOpacity
                style={[
                  Styles.bottomTxtView,
                  {
                    backgroundColor: Color.WHITE,
                    borderColor: "#ed9c26",
                    borderWidth: 2,
                    padding: 6,
                  },
                ]}
                onPress={() => this.props.navigation.pop(1)}
              >
                <Text
                  style={[
                    Styles.bottomBtnText,
                    {
                      color: "#ed9c26",
                      fontFamily: this.props.fontFamily,
                      fontSize: this.props.fontSize,
                    },
                  ]}
                >
                  {STRINGS.back}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  Styles.bottomTxtView,
                  {
                    backgroundColor: "#ed9c26",
                    borderColor: "#ed9c26",
                    borderWidth: 2,
                    padding: 6,
                  },
                ]}
                onPress={this.nextStep}
              >
                <Text
                  style={[
                    Styles.bottomBtnText,
                    {
                      fontFamily: this.props.fontFamily,
                      fontSize: this.props.fontSize,
                    },
                  ]}
                >
                  {STRINGS.next}
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </View>
        {/* Date Picker */}
        <DateTimePicker
          cancelTextIOS={STRINGS.cancel}
          confirmTextIOS={STRINGS.confirm_s}
          isVisible={this.props.datePickerVisible}
          onConfirm={this.datePicked}
          onCancel={this.cancelDatePicker}
          date={
            this.props.birthdate !== STRINGS.choose_date &&
              this.props.birthdate !== ""
              ? moment(this.props.birthdate, "YYYY-MM-DD").toDate()
              : moment().subtract(25, "years").toDate()
          }
        />

        {/* Address Modal */}
        {/* <Modal
          ref={el => (this.addressModal = el)}
          style={Styles.modal}
          position={'top'}
          animationDuration={250}
          entry="top"
          swipeToClose={false}
          onClosed={() => this.props.updateState({ showMapView: false })}
        >
          <View style={Styles.modalView}>
            <Text style={[Styles.modalInputTitle, { alignSelf: 'center' }]}>{STRINGS.address}</Text>
            <Text style={[styles.modalText]}>{this.getAddress(this.props.isSecondAddress)}</Text>
            {this.props.showMapView && (
              <View style={{ height: 300, width: Styles.modal.width - 24 }}>
                <MapView
                  ref={el => (this.mapView = el)}
                  style={{ flex: 1 }}
                  initialRegion={this.props.mapRegion}
                  onLongPress={e => this.mapViewLongClick(e)}
                >
                  <MapView.Marker
                    key={`${this.props.isSecondAddress}`}
                    coordinate={this.props.isSecondAddress ? this.props.secondUserLocation : this.props.userLocation}
                  />
                </MapView>
                <TouchableOpacity style={styles.locationIcon} onPress={() => this.getUserLocation()}>
                  <MaterialIcons name="my-location" size={28} color="white" />
                </TouchableOpacity>
              </View>
            )}
            {Styles.renderVSeparator(12)}
            <Text style={[styles.modalText, { color: Color.RED[500] }]}>* {STRINGS.long_click_desc}</Text>
            <View style={[Styles.modalBtnsView, { marginTop: 12 }]}>
              <Button
                title={STRINGS.confirm}
                style={[Platform.OS === 'android' && { marginLeft: 8 }]}
                onPress={() => this.addressModal.close()}
              />
            </View>
          </View>
        </Modal> */}
      </View>
    );
  }

  datePicked = (date) => {
    const birthdate = moment(date).format("YYYY-MM-DD");
    this.props.updateState({ birthdate });
    this.cancelDatePicker();
  };

  showDatePicker = () => {
    this.props.updateState({ datePickerVisible: true });
  };

  cancelDatePicker = () => {
    this.props.updateState({ datePickerVisible: false });
  };

  nextStep = () => {
    const {
      firstName,
      lastName,
      birthdate,
      gender,
      mobile,
      maritalStatus,
      numOfChildren,
      userLocation,
      address,
      user,
      isUpdate,
    } = this.props;
    if (
      firstName.trim() === "" ||
      lastName.trim() === "" ||
      mobile.trim() === ""
      // ||
      // address.trim() === ''
    ) {
      Commons.fillAllFields();
      return;
    }
    const mobileNo = mobile.trim().split("@")[0];
    if (mobileNo.length !== 10 || !mobileNo.startsWith("07")) {
      Commons.okMsgAlert(STRINGS.invalid_mobile_number);
      return;
    }
    this._removeKeyboardListeners();
    this.props.navigation.push("registerSecondStep", {
      firstName,
      lastName,
      birthdate,
      gender,
      mobile,
      maritalStatus,
      numOfChildren,
      userLocation,
      address,
      user,
      isUpdate,
      _addKeyboardListeners: this._addKeyboardListeners,
    });
  };

  mapViewLongClick = (e) => {
    const userLocation = e.nativeEvent.coordinate;
    this.applyNewLocation(userLocation);
  };

  getUserLocation = async () => {
    if (this._mounted) {
      // if (Platform.OS === 'android' && !ExpoConstants.isDevice) {
      //   Commons.okMsgAlert(STRINGS.emulator_location_msg);
      //   return;
      // }
      // if ((await Permissions.getAsync(Permissions.LOCATION)).status !== 'granted') {
      //   await Commons.confirmAlert(STRINGS.location_services, STRINGS.location_perpose, async () => {
      //     const { status } = await Permissions.askAsync(Permissions.LOCATION);
      //     if (status !== 'granted') {
      //       Commons.okMsgAlert(STRINGS.location_permission_denied);
      //       return;
      //     }
      //     const providerStatus = await Location.getProviderStatusAsync();
      //     if (!providerStatus.locationServicesEnabled) {
      //       Commons.okMsgAlert(STRINGS.enable_location_services);
      //       return;
      //     }
      //     const location = await Location.getCurrentPositionAsync({});
      //     this.applyNewLocation(location.coords);
      //   });
      // }
    }
  };

  applyNewLocation = async (location) => {
    const addressObj = (await Location.reverseGeocodeAsync(location))[0];
    const { latitude, longitude } = location;
    const mapRegion = {
      latitude: latitude,
      longitude: longitude,
      latitudeDelta: 0.02,
      longitudeDelta: 0.02,
    };
    const userLocation = {
      latitude: latitude,
      longitude: longitude,
    };
    this.moveToRegion(mapRegion);
    const address = `${addressObj.city}, ${addressObj.region}, ${addressObj.street}`;
    const newAddress = this.getNewAddress(address, this.props.isSecondAddress);

    const extraProps = !this.props.isSecondAddress
      ? { userLocation, mapRegion }
      : { secondUserLocation: userLocation, secondMapRegion: mapRegion };

    this.props.updateState({ address: newAddress, ...extraProps });
  };

  moveToRegion = (mapRegion) => {
    try {
      this.mapView.animateToRegion(mapRegion, 400);
    } catch (error) {
      // ignore
    }
  };

  getNewAddress = (address, isSecond) => {
    let newAddress = "";
    if (isSecond) {
      newAddress = `${this.getAddress(false)}@@${address}`;
    } else {
      newAddress = `${address}@@${this.getAddress(true)}`;
    }
    return newAddress;
  };

  getAddress = (isSecondAddress) => {
    const addresses = this.props.address.split("@@");
    if (isSecondAddress) {
      if (addresses.length > 1) {
        return addresses[1];
      }
      return "";
    }
    return addresses[0];
  };

  getNewMobile = (mobile, pos) => {
    let newMobile = "";
    if (pos === 0) {
      newMobile = `${mobile}@@${this.getMobile(1)}@@${this.getMobile(2)}`;
    } else if (pos === 1) {
      newMobile = `${this.getMobile(0)}@@${mobile}@@${this.getMobile(2)}`;
    } else {
      newMobile = `${this.getMobile(0)}@@${this.getMobile(1)}@@${mobile}`;
    }
    return newMobile;
  };

  getMobile = (pos) => {
    const mobiles = this.props.mobile.split("@@");
    if (pos === 0) {
      return mobiles[0];
    }
    if (pos === 1) {
      if (mobiles.length > 1) {
        return mobiles[1];
      }
      return "";
    }
    if (mobiles.length > 2) {
      return mobiles[2];
    }
    return "";
  };
}

const myStyle = (props) => {
  return {
    container: {
      flex: 1,
      padding: 16,
      justifyContent: "space-between",
      paddingBottom: 20,
    },
    modalText: {
      fontSize: 17,
      alignSelf: "center",
      color: "#6b3529",
      marginBottom: 12,
      textAlign: "center",
      fontFamily: "zarid",
    },
    title: {
      fontSize: props.fontSize,
      fontFamily: props.fontFamily,
      alignSelf: "center",
      color: "#6b3529",
      marginBottom: 12,
    },
    optionView: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 12,
    },
    labelView: {
      flex: 1,
      backgroundColor: "rgba(255,255,255,0.3)",
      alignItems: "center",
    },
    label: {
      color: "#6b3529",
      textAlign: "center",
      padding: 10,
      fontSize: props.fontSize,
      fontFamily: props.fontFamily,
    },
    input: {
      flex: 1.5,
      height: 42,
      backgroundColor: "white",
      paddingLeft: 8,
      fontSize: 18,
      color: "#6b3529",
      fontFamily: "zarid",
    },
    hint: {
      fontSize: 16,
      color: Color.GREY[400],
      textAlign: "left",
    },
    arrow: {
      position: "absolute",
      right: 12,
    },
    mapIcon: {
      position: "absolute",
      right: 0,
      paddingHorizontal: 6,
      backgroundColor: "white",
    },
    locationIcon: {
      position: "absolute",
      right: 8,
      bottom: 8,
      padding: 6,
      borderRadius: 4,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };
};

const mapStateToProps = ({ registerFirstStep }) => registerFirstStep;

export default connect(mapStateToProps, actions)(RegisterFirstStep);
